/**
 * usePendingMerchsCount — compteur badge ModuleSelector (FEAT-VALIDATION-WORKFLOW).
 */
import { useQuery } from '@tanstack/react-query';
import { fetchPendingMerchsCount } from '../lib/api';

export function usePendingMerchsCount() {
  return useQuery({
    queryKey: ['admin', 'pending-merchs-count'],
    queryFn:  fetchPendingMerchsCount,
    staleTime: 60_000,
    retry: 1,
  });
}
